import { useState, useEffect, useRef } from '@wordpress/element';
import { useDispatch }                  from '@wordpress/data';
import { __ }                           from '@wordpress/i18n';
import { STORE_NAME }                   from '../../../store';
import { debounce }                     from '../../../utils/helpers';

export default function SearchFilter( { debounceMs = 400 } ) {
	const [ value, setValue ]  = useState( '' );
	const { setSearch }        = useDispatch( STORE_NAME );
	const debouncedRef         = useRef( null );

	useEffect( () => {
		debouncedRef.current = debounce( setSearch, debounceMs );
	}, [ debounceMs, setSearch ] );

	function handleChange( e ) {
		const v = e.target.value;
		setValue( v );
		debouncedRef.current( v );
	}

	function handleClear() {
		setValue( '' );
		setSearch( '' );
	}

	return (
		<div className="mwsb-filter mwsb-filter--search">
			<div className="mwsb-search-wrap">
				<svg className="mwsb-search-icon" viewBox="0 0 24 24" width="16" height="16">
					<path d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
				</svg>
				<input
					type="search"
					className="mwsb-search-input"
					placeholder={ __( 'Search products…', 'mwsb' ) }
					value={ value }
					onChange={ handleChange }
					aria-label={ __( 'Search products', 'mwsb' ) }
				/>
				{ value && (
					<button className="mwsb-search-clear" onClick={ handleClear } aria-label={ __( 'Clear search', 'mwsb' ) }>
						&times;
					</button>
				) }
			</div>
		</div>
	);
}
